module.exports = __webpack_public_path__ + "static/media/cart.e43f421b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svgs/cart.svg
// module id = 188
// module chunks = 0